// Shared look for the Create Campaign steps (presentation only).
import { Avatar, Box, Stack, Typography } from "@mui/material";

// Step card: white, rounded, light border
export const stepCardSx = {
    borderRadius: 3,
    border: "1px solid #e9edf2",
    boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
    overflow: "visible",
};

// Footer row: buttons on the right, light divider above
export const stepActionsSx = {
    display: "flex",
    justifyContent: "flex-end",
    px: { xs: 2, sm: 3 },
    py: 2,
    borderTop: "1px solid #e9edf2",
    // phones: Back / Next side by side, each half the width
    "& > .MuiStack-root": { width: { xs: "100%", sm: "auto" } },
    "& > .MuiStack-root > *": { flex: { xs: 1, sm: "0 0 auto" } },
    "& .MuiButton-root": { width: { xs: "100%", sm: "auto" } },
};

// Phones: buttons are half-width (see stepActionsSx), so long labels ("Create Organization")
// get less padding / smaller text and may wrap to 2 lines inside a growing button instead of spilling out.
const baseBtn = {
    height: { xs: "auto", sm: 42 },
    minHeight: 42,
    minWidth: { xs: 0, sm: 110 },
    px: { xs: 1.5, sm: 3 },
    lineHeight: { xs: 1.25, sm: 1.75 },
    borderRadius: 3,
    textTransform: "none",
    fontSize: { xs: 13.5, sm: 14.5 },
    fontWeight: 700,
    boxShadow: "none",
};

// Back: white with grey border
export const backBtnSx = {
    ...baseBtn,
    color: "#475569",
    bgcolor: "#fff",
    border: "1.5px solid #e2e8f0",
    "&:hover": { bgcolor: "#f8fafc", borderColor: "#cbd5e1", boxShadow: "none" },
    "&.Mui-disabled": { color: "#cbd5e1", bgcolor: "#fff", borderColor: "#f1f5f9", cursor: "not-allowed" },
};

// Next / Submit: blue gradient
export const nextBtnSx = {
    ...baseBtn,
    color: "#fff",
    border: "none",
    background: "linear-gradient(135deg, #2563eb, #3b82f6)",
    "&:hover": { background: "linear-gradient(135deg, #1d4ed8, #2563eb)", boxShadow: "0 8px 18px -8px #2563eb" },
    "&.Mui-disabled": { color: "#fff", background: "#93c5fd", opacity: 0.85, cursor: "not-allowed" },
};

// Step heading: icon tile + title + subtitle
export function StepHeader({ icon, title, subtitle, right }) {
    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1.5}
            flexWrap="wrap" // phones: the optional `right` content drops below the title instead of squeezing it
            useFlexGap
            sx={{ pb: 1.75, mb: 2.5, borderBottom: "1px solid #e9edf2" }}
        >
            <Stack direction="row" alignItems="center" spacing={1.25} sx={{ minWidth: 0 }}>
                <Avatar variant="rounded" sx={{ width: 36, height: 36, borderRadius: 2, color: "#2563eb", bgcolor: "#2563eb14" }}>
                    {icon}
                </Avatar>
                <Box sx={{ minWidth: 0 }}>
                    <Typography variant="subtitle1" fontWeight={700} lineHeight={1.25} color="#0f172a">
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="caption" color="text.secondary">
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Stack>
            {right}
        </Stack>
    );
}
